var _g, _g2, _g3, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo0(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "171px",
    height: "193.999px",
    viewBox: "0 0 171 193.999",
    enableBackground: "new 0 0 171 193.999",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#77C37E",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 86.783,171.788 86.783,137.788 86.783,101.788 86.783,93.788 100.283,64.538 88.033,37.038 75.284,64.538  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#77C37E",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 75.284,
    y1: 64.538,
    x2: 86.783,
    y2: 93.788
  })), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#77C37E",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 85.652,128.05 71.284,113.897 60.617,85.788 25.617,75.747 41.284,106.872  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#77C37E",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 41.284,
    y1: 106.872,
    x2: 71.284,
    y2: 113.897
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#77C37E",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 117.033,110.288 86.783,104.413 114.783,85.788 141.033,95.788  "
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#6DBD45",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 84.457,174.303 84.457,140.303 84.457,104.303 84.457,96.303 97.957,67.053 85.707,39.553 72.957,67.053  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6DBD45",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 72.957,
    y1: 67.053,
    x2: 84.457,
    y2: 96.303
  })), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#6DBD45",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 83.326,130.564 68.957,116.412 58.29,88.303 23.29,78.262 38.957,109.387  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6DBD45",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 38.957,
    y1: 109.387,
    x2: 68.957,
    y2: 116.412
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#6DBD45",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 114.707,112.803 84.457,106.928 112.457,88.303 138.706,98.303  "
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#A3D184",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 84.456,171.788 84.456,137.788 84.456,101.788 84.456,93.788 97.956,64.538 85.706,37.038 72.956,64.538  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A3D184",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 72.956,
    y1: 64.538,
    x2: 84.456,
    y2: 93.788
  })), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#A3D184",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 83.325,128.05 68.956,113.897 58.29,85.788 23.29,75.747 38.956,106.872  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A3D184",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 38.956,
    y1: 106.872,
    x2: 68.956,
    y2: 113.897
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#A3D184",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 114.706,110.288 84.456,104.413 112.456,85.788 138.706,95.788  "
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#A6C777",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 86.783,171.788 86.783,137.788 86.783,101.788 86.783,93.788 100.283,64.538 88.033,37.038 75.283,64.538  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A6C777",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 75.283,
    y1: 64.538,
    x2: 86.783,
    y2: 93.788
  })), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#A6C777",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 85.652,128.05 71.283,113.897 60.616,85.788 25.617,75.747 41.283,106.872  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A6C777",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 41.283,
    y1: 106.872,
    x2: 71.283,
    y2: 113.897
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#A6C777",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 117.033,110.288 86.783,104.413 114.783,85.788 141.033,95.788  "
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#48B75E",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 84.456,171.788 84.456,137.788 84.456,101.788 84.456,93.788 97.956,64.538 85.706,37.038 72.956,64.538  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#48B75E",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 72.956,
    y1: 64.538,
    x2: 84.456,
    y2: 93.788
  })), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#48B75E",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 83.325,128.05 68.956,113.897 58.29,85.788 23.29,75.747 38.956,106.872  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#48B75E",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 38.956,
    y1: 106.872,
    x2: 68.956,
    y2: 113.897
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#48B75E",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 114.706,110.288 84.456,104.413 112.456,85.788 138.706,95.788  "
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#29B473",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 84.457,173.343 84.457,139.343 84.457,103.343 84.457,95.343 97.957,66.093 85.707,38.593 72.957,66.093  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#29B473",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 72.957,
    y1: 66.093,
    x2: 84.457,
    y2: 95.343
  })), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#29B473",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 83.326,129.604 68.957,115.452 58.29,87.343 23.29,77.302 38.957,108.427  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#29B473",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 38.957,
    y1: 108.427,
    x2: 68.957,
    y2: 115.452
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#29B473",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 114.707,111.843 84.457,105.968 112.457,87.343 138.707,97.343  "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo0);
export default __webpack_public_path__ + "static/media/logo0.ee8bde5a0da46b651c7ec6008dbf90ca.svg";
export { ForwardRef as ReactComponent };